function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { kebabCase } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/containers/icon';
import { formatCabinetCellValue } from '../../utils/cabinetColumnUtils';
const getRowDisplay = (indexes, index, data) => {
  if (indexes && indexes.length) {
    return indexes.map(currentIndex => `${formatCabinetCellValue(data[currentIndex])} `);
  }
  return formatCabinetCellValue(data[index]);
};
const CabinetRow = ({
  id,
  columns,
  data,
  onClick,
  onSelect,
  rowIndex,
  hasActions: _hasActions = false,
  isSelected: _isSelected = false,
  isDeleted: _isDeleted = false
}) => {
  const handleClick = onClick.bind(null, id);
  const handleSelect = event => onSelect(id, event);
  let checkbox;
  if (_hasActions) {
    checkbox = /*#__PURE__*/React.createElement("td", {
      "aria-label": "select-row-checkbox",
      style: {
        width: '1px',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "t-cr-check",
      "data-testid": `t-cr-check-${id}`,
      type: "checkbox",
      checked: _isSelected,
      onChange: handleSelect
    }));
  }
  const renderCellContent = ({
    style: _style = '',
    icon,
    index,
    indexes,
    color
  }, cellData) => {
    const value = getRowDisplay(indexes, index, cellData);
    if (_style === 'iconIfPresent' && cellData[index]) {
      return /*#__PURE__*/React.createElement(Icon, {
        style: {
          textAlign: 'center',
          fontSize: '24px',
          color
        },
        glyph: icon
      });
    }
    if (_style === 'smallText') {
      return /*#__PURE__*/React.createElement("small", null, value);
    }

    // Numeric indexes arrive as DECIMAL strings ("45.0000").
    if (_style === 'percent' && value !== '' && Number.isFinite(Number(value))) {
      return /*#__PURE__*/React.createElement("span", null, `${Math.round(Number(value))}%`);
    }
    if (_style === 'largeDate' && value) {
      return /*#__PURE__*/React.createElement("span", null, moment(value).format('MM/DD/YYYY'));
    }
    if (_style === 'smallDate' && value) {
      return /*#__PURE__*/React.createElement("small", null, moment(value).format('MM/DD/YYYY'));
    }
    if (_style === 'largeDateTime' && value) {
      return /*#__PURE__*/React.createElement("span", null, moment(value).format('MM/DD/YYYY HH:mm'));
    }
    if (_style === 'smallDateTime' && value) {
      return /*#__PURE__*/React.createElement("small", null, moment(value).format('MM/DD/YYYY HH:mm'));
    }
    return value;
  };
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": `cabinet-row-${id}`,
    className: `t-cr-${rowIndex}`,
    style: {
      height: '30px'
    }
  }, checkbox, columns.map(({
    align,
    rows,
    title,
    width
  }) => /*#__PURE__*/React.createElement("td", {
    key: `col-${rowIndex}-${kebabCase(title)}}-${data.id}`,
    style: _objectSpread({
      textAlign: align || 'left'
    }, _isDeleted ? {
      opacity: 0.5,
      cursor: 'default'
    } : {}),
    width: width
  }, rows.map(({
    icon,
    index,
    indexes,
    style: _style2 = '',
    color
  }) => /*#__PURE__*/React.createElement("div", {
    className: `t-cr-${data.id}-${kebabCase(title)}`,
    key: `div-${rowIndex}-${index || indexes.join('')})}-${data.id}`,
    role: _isDeleted ? undefined : 'link',
    tabIndex: _isDeleted ? undefined : '0',
    onClick: _isDeleted ? undefined : handleClick,
    onKeyPress: _isDeleted ? undefined : handleClick
  }, renderCellContent({
    style: _style2,
    icon,
    index,
    indexes,
    color
  }, data))))));
};
CabinetRow.propTypes = {
  id: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      index: PropTypes.string,
      indexes: PropTypes.arrayOf(PropTypes.string),
      style: PropTypes.string
    }))
  })).isRequired,
  data: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  hasActions: PropTypes.bool,
  isDeleted: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired
};
export default CabinetRow;